import React from "react";
import { Card, Row, Col } from "react-bootstrap";
import ReactWebChat from "botframework-webchat";
import ellipse from "./assets/images/ellipse.png";
import AADService from "../../AADService";

const styleOptions = {
  botAvatarImage: ellipse,
  botAvatarInitials: "",
  botAvatarBackgroundColor: "white",
  bubbleBorderRadius: 25,
  avatarSize: 40,
  //bubbleBorderWidth: 1.5,
  bubbleTextColor: "black",
  bubbleBackground: "#f2f2f2",
  bubbleFromUserBorderColor: "#00233d",
  bubbleFromUserBackground: "#00233d",
  bubbleFromUserBorderRadius: 10,
  bubbleFromUserBorderWidth: 1.2,
  bubbleFromUserTextColor: "white",
  hideUploadButton: true,
  sendBoxBackground: "white",
  sendBoxHeight: 50,
  sendBoxTextColor: "black",
  sendBoxBorderLeft: "solid 2px #f2f2f2",
  sendBoxBorderRight: "solid 2px #f2f2f2",
  sendBoxButtonColorOnFocus: "white",
  sendBoxButtonColorOnHover: "white",
  sendBoxButtonColor: "white",
  bubbleFromUserNubOffset: "bottom",
  bubbleFromUserNubSize: 10,
  timestampColor: "#00233d",
};

class ChatBot extends React.Component {
  render() {
    const { user, directLine } = this.props;

    // Retreiving User's First Name
    const AzureADService = new AADService();
    const email = AzureADService.getUser().userName;
    const userName = email.substring(0, email.indexOf("."));
    const firstname = userName.charAt(0).toUpperCase() + userName.slice(1);

    return (
      <Row>
        <Col md={6} xl={4}>
          <Card className="chatbot-card">
            <Card.Header className="chatbotheader">
              <span style={{ fontSize: "30px", marginLeft: "10px" }}>
                Hi {firstname}
              </span>
              <br />

              <div className="chatbot-title">
                {/* <span style={{ fontSize: "30px" }}>Hi {firstname}</span><br /> */}

                <span>
                  We're here to answer your questions about <br />
                  Maestro. Ask us anything.
                </span>
              </div>
              {/* <i
                                className='chatbot-close fa fa-times-thin pull-right fa-2x'
                                aria-hidden='true'
                                onClick={() => handleClose(false)}
                            ></i> */}
            </Card.Header>

            <ReactWebChat
              className="webchat"
              styleOptions={styleOptions}
              directLine={directLine}
              userID={user}
            ></ReactWebChat>
          </Card>
        </Col>
      </Row>
    );
  }
}
export default ChatBot;
